import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d17659fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "¿Es por alguno de estos motivos?", -1))
const _hoisted_3 = {
  class: "motive-container",
  role: "radiogroup",
  "aria-label": "Motivos de cancelación"
}
const _hoisted_4 = ["for"]
const _hoisted_5 = ["id", "value"]
const _hoisted_6 = { class: "button-set" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.motives, (motive, index) => {
            return (_openBlock(), _createElementBlock("label", {
              class: _normalizeClass(["option", { selected: _ctx.isSelected(motive.id) }]),
              key: _ctx.motiveInputId(motive, index),
              for: _ctx.motiveInputId(motive, index)
            }, [
              _withDirectives(_createElementVNode("input", {
                id: _ctx.motiveInputId(motive, index),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMotive) = $event)),
                value: motive.id,
                type: "radio",
                name: "motive"
              }, null, 8, _hoisted_5), [
                [_vModelRadio, _ctx.selectedMotive]
              ]),
              _createElementVNode("span", null, _toDisplayString(motive.motive), 1)
            ], 10, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            variant: "turquoise",
            disabled: !_ctx.hasSelectedMotive,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Guardar ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _: 1
  }))
}